import React, {Component} from 'react';
import {Checkbox, Col, ControlLabel, Form, FormGroup} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import '../../../../../styles/KalendarzTable.css'
import CurrencyInput from '../../../../../componentsTopsa/currencyInput/CurrencyInput'


export default class WynajemContainer extends Component {
    constructor(props) {
        super(props);

        if (localStorage.getItem('EBUS_EdycjaWynajem') === null) {
            this.state = {
                formaPlatnosci: '',
                formyPlatnosci: [{value: 'GOTÓWKA', label: 'GOTÓWKA'}, {value: 'PRZELEW', label: 'PRZELEW'}],
                cenaKm: 0,
                cenaWynajmu: 0,
                liczbaKm: 0,
                czescStala: 0,
                kosztyKierowcow: 0,
                oplatyDrogowe: 0,
                pozostaleOplaty: 0,
                zaliczka: 0,
                oplacone: false,
                faktura: false
            };
        } else {
            this.state = {
                formaPlatnosci: this.props.data.formaPlatnosci,
                formyPlatnosci: [{value: 'GOTÓWKA', label: 'GOTÓWKA'}, {value: 'PRZELEW', label: 'PRZELEW'}],
                cenaWynajmu: this.props.data.cenaWynajmu,
                cenaKm: this.props.data.cenaKm,
                liczbaKm: this.props.data.liczbaKm,
                czescStala: this.props.data.czescStala,
                kosztyKierowcow: this.props.data.kosztyKierowcow,
                oplatyDrogowe: this.props.data.oplatyDrogowe,
                pozostaleOplaty: this.props.data.pozostaleOplaty,
                zaliczka: this.props.data.zaliczka,
                oplacone: this.props.data.oplacone,
                faktura: this.props.data.faktura
            };
        }

        this.onChangeCenaWynajmu = this.onChangeCenaWynajmu.bind(this);
        this.onChangeFormaPlatnosci = this.onChangeFormaPlatnosci.bind(this);
        this.onChangeCenaKm = this.onChangeCenaKm.bind(this);
        this.onChangeLiczbaKm = this.onChangeLiczbaKm.bind(this);
        this.onChangeCzescStala = this.onChangeCzescStala.bind(this);
        this.onChangeKosztyKierowcow = this.onChangeKosztyKierowcow.bind(this);
        this.onChangeOplatyDrogowe = this.onChangeOplatyDrogowe.bind(this);
        this.onChangePozostaleOplaty = this.onChangePozostaleOplaty.bind(this);
        this.onChangeZaliczka = this.onChangeZaliczka.bind(this);
        this.onChangeOplacone = this.onChangeOplacone.bind(this);
        this.onChangeFaktura = this.onChangeFaktura.bind(this);

    }

    onChangeCenaWynajmu(e, maskedvalue, floatvalue) {
        this.setState({cenaWynajmu: e})
        this.props.setCenaWynajmu(e)
    }

    onChangeFormaPlatnosci(e) {
        this.setState({formaPlatnosci: e})
        this.props.setFormaPlatnosci(e.label)
    }

    onChangeCenaKm(e, maskedvalue, floatvalue) {
        this.setState({cenaKm: e})
        this.props.setCenaKm(e)
    }

    onChangeLiczbaKm(e) {
        this.setState({liczbaKm: e.target.value})
        this.props.setLiczbaKm(e.target.value)
    }

    onChangeCzescStala(e, maskedvalue, floatvalue) {
        this.setState({czescStala: e})
        this.props.setCzescStala(e)
    }

    onChangeKosztyKierowcow(e, maskedvalue, floatvalue) {
        this.setState({kosztyKierowcow: e})
        this.props.setKosztyKierowcow(e)
    }

    onChangeOplatyDrogowe(e, maskedvalue, floatvalue) {
        this.setState({oplatyDrogowe: e})
        this.props.setOplatyDrogowe(e)
    }

    onChangePozostaleOplaty(e, maskedvalue, floatvalue) {
        this.setState({pozostaleOplaty: e})
        this.props.setPozostaleOplaty(e)
    }

    onChangeZaliczka(e, maskedvalue, floatvalue) {
        this.setState({zaliczka: e})
        this.props.setZaliczka(e)
    }

    onChangeOplacone() {
        this.props.setOplacone(!this.state.oplacone)
        this.setState({oplacone: !this.state.oplacone})
    }

    onChangeFaktura() {
        this.props.setFaktura(!this.state.faktura)
        this.setState({faktura: !this.state.faktura})
    }

    render() {

        return (
            <Col sm={6}>
                <fieldset>
                    <div className={'fieldset-label'}>Dane płatności</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Forma płatności:</ControlLabel>
                                <TopSelect onChange={this.onChangeFormaPlatnosci}
                                           value={this.state.formaPlatnosci}
                                           options={this.state.formyPlatnosci}
                                           clearable={false}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Cena za km:</ControlLabel>
                                <CurrencyInput onChange={(e)=>this.onChangeCenaKm(e)}
                                       value={this.state.cenaKm}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Liczba km:</ControlLabel>
                                <input className="form-control" type="number" onChange={(e) => this.onChangeLiczbaKm(e)}
                                       value={this.state.liczbaKm}/>
                            </Col></FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Część stała: </ControlLabel>
                                <CurrencyInput onChange={(e) => this.onChangeCzescStala(e)}
                                       value={this.state.czescStala}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Koszty kierowców: </ControlLabel>
                                <CurrencyInput onChange={(e) => this.onChangeKosztyKierowcow(e)}
                                       value={this.state.kosztyKierowcow}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Opłaty drogowe: </ControlLabel>
                                <CurrencyInput onChange={(e) => this.onChangeOplatyDrogowe(e)}
                                       value={this.state.oplatyDrogowe}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Pozostałe opłaty: </ControlLabel>
                                <CurrencyInput value={this.state.pozostaleOplaty} onChange={(e) => this.onChangePozostaleOplaty(e)}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Cena wynajmu:</ControlLabel>
                                <CurrencyInput value={this.state.cenaWynajmu}
                                               onChange={(e) => this.onChangeCenaWynajmu(e)}/>
                            </Col>
                        </FormGroup>

                        <FormGroup>
                            <Col xs={12} lg={8}>
                                <ControlLabel>Zaliczka:</ControlLabel>
                                <CurrencyInput onChange={(e) => this.onChangeZaliczka(e)}
                                       value={this.state.zaliczka}/>
                            </Col>
                        </FormGroup>

                        <FormGroup style={{paddingBottom: 20}}>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Opłacone</ControlLabel>
                                <Checkbox onChange={this.onChangeOplacone}
                                          checked={this.state.oplacone} title="Opłacone"/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <ControlLabel>Faktura FV</ControlLabel>
                                <Checkbox onChange={this.onChangeFaktura}
                                          checked={this.state.faktura} title="Faktura"/>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </Col>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/formularz/components/DanePlatnosci.js